import { render } from "./package_only.vue?vue&type=template&id=60c55af4"
import script from "./package_only.vue?vue&type=script&lang=js"
export * from "./package_only.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__